import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sh_url: 'http://sh.zzyxzs.com',
    dls_url: 'http://agent.zzyxzs.com',
    down_url: 'https://update.zzyxzs.com/soft/zzclient.zip', // 核心端
    down_url_server: 'https://update.zzyxzs.com/soft/zzserver.zip', // 服务端
    down_url_console: 'https://update.zzyxzs.com/soft/manager.zip',
    offsetTop: 0
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
